import { render, staticRenderFns } from "./safe-build.vue?vue&type=template&id=66c7b734&"
import script from "./safe-build.vue?vue&type=script&lang=js&"
export * from "./safe-build.vue?vue&type=script&lang=js&"
import style0 from "./safe-build.vue?vue&type=style&index=0&id=66c7b734&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports